import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const ReportReviewBlock = styled('div')`
  margin-top: 15px;
  border: 1px solid var(--ph-gray-50);
`;

const ReportReviewNoteInfoBox = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 10px;
`;

const ReportReviewNoteBoxNoteInfoLeft = styled('div')`
  flex: 1;
`;

const ReportReviewBlockNoteTimeBox = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

const ReportReviewBlockNoteTime = styled('div')`
  display: inline-flex;
`;

const ReportReviewBlockNoteTimeLabel = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
`;

const ReportReviewBlockNoteTimeText = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
`;

const ReportReviewNoteText = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
  padding: 10px;
  overflow-wrap: break-word;
`;

const ReportReviewNoteLine = styled('div')`
  width: 100%;
  height: 2px;
  border-top: 1px solid var(--ph-gray-50);
`;

const ReportReviewCommentLine = styled('div')`
  width: calc(100%);
  height: 2px;
  border-top: 1px solid var(--ph-gray-50);
`;

const ReportReviewNoteBoxNoteInfoLeftIn = styled('div')`
  font-size: var(--ph-text-sm);
  position: relative;
  white-space: nowrap;
  margin-bottom: 5px;
`;

const ReportReviewCommentInfoBox = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
`;

const ReportReviewCommentBoxInfoLeft = styled('div')`
  flex: 1;
`;

const ReportReviewCommentBoxInfoLeftIn = styled('div')`
  position: relative;
  white-space: nowrap;
`;

const ReportReviewCommentBox = styled('div')`
  padding: 10px;
`;

const ReportReviewCommentText = styled('div')`
  font-size: var(--ph-text-sm);
  color: var(--black);
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 15px;
  overflow-wrap: break-word;

  &.isLastComment {
    margin-bottom: 0;
  }
`;

const ClosedSpan = styled('span')`
  cursor: not-allowed;
  font-size: var(--ph-text-xs);
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-green-500);
  color: var(--white);
  padding-left: 8px;
  padding-right: 8px;
  height: 24px;
  min-width: 24px;
  display: inline-flex;

  &.open {
    background-color: var(--ph-red-500);
  }

  &.pointer {
    cursor: pointer;
  }

  & + & {
    margin-left: 5px;
  }

  &.editDelete {
    transition: var(--ph-transition);
    background-color: var(--transparent);
    color: var(--ph-gray-500);
    cursor: pointer;

    &:hover {
      background-color: var(--ph-gray-25);
      color: var(--ph-gray-700);
    }

    &:active {
      background-color: var(--ph-gray-50);
      color: var(--ph-gray-700);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.disabled {
    color: var(--ph-gray-500);
    cursor: not-allowed;
  }
`;

const ToggleSvg = styled(Svg)`
  width: 12px;
  fill: var(--white);
  top: 2px;

  &.collapsed {
    transform: rotate(-90deg);
  }
  cursor: pointer;
`;

const ToggleTransBtn = styled('div')`
  position: absolute;
  top: 115%;
  width: 137px;
  height: 44px;
  padding: 10px;
  color: var(--black);
  box-shadow: var(--ph-box-shadow-sm);
  background-color: var(--white);
  border-radius: var(--ph-border-radius-sm);
  z-index: 2;
  cursor: pointer;
`;

const ToggleTransOptionBlock = styled('div')`
  font-size: var(--ph-text-sm);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

const ReportReviewNoteTextAreaWrapper = styled('div')`
  margin: 1px;
`;

const ReportReviewBlockTimeWrapperDiv = styled('div')`
  position: relative;
`;

const ReportReviewAddingCommentBlock = styled('div')`
  display: block;
  width: 100%;
  padding: 10px;
`;

const ReportReviewAddingCommentButtons = styled('div')`
  padding-top: 15px;
`;

const NewNoteTitleText = styled('div')`
  margin-bottom: 16px;
  margin-right: 1px;
  font-weight: bold;
`;

const UpdateNoteTrixDiv = styled('div')`
  margin: 0 25px;
`;

const ButtonEditDelete = styled('button')`
  &.disabled {
    color: grey;
  }

  &.marginLeft {
    margin-left: 5px;
  }
`;

const ReportReviewNoteIsExternalComment = styled('div')`
  margin: 0 20px;
`;

export default {
  ReportReviewBlock,
  ReportReviewNoteInfoBox,
  ReportReviewNoteBoxNoteInfoLeft,
  ReportReviewBlockNoteTimeBox,
  ReportReviewBlockNoteTime,
  ReportReviewBlockNoteTimeLabel,
  ReportReviewBlockNoteTimeText,
  ReportReviewNoteText,
  ReportReviewNoteLine,
  ReportReviewCommentLine,
  ReportReviewNoteBoxNoteInfoLeftIn,
  ReportReviewCommentInfoBox,
  ReportReviewCommentBoxInfoLeft,
  ReportReviewCommentBoxInfoLeftIn,
  ReportReviewCommentBox,
  ReportReviewCommentText,
  ClosedSpan,
  ToggleSvg,
  ToggleTransBtn,
  ToggleTransOptionBlock,
  ReportReviewNoteTextAreaWrapper,
  ReportReviewBlockTimeWrapperDiv,
  ReportReviewAddingCommentBlock,
  ReportReviewAddingCommentButtons,
  NewNoteTitleText,
  UpdateNoteTrixDiv,
  ButtonEditDelete,
  ReportReviewNoteIsExternalComment,
};
